<template>
  <div class="favorite">
    <div class=" title">
      <span class="font-h1">我的收藏</span>
      <favorite-search ref="favoriteSearch" :appId="appId" @search="search"></favorite-search>
    </div>
    <base-table
      v-loading="dataLoading"
      :data="favoriteList"
      @row-click="favoriteClick"
      show-line-height-box
      :page-info="pageInfo"
      @page-change="refreshTable"
    >
      <el-table-column
        v-for="col in favoriteColumns"
        :key="col.value"
        :prop="col.value"
        :label="col.label"
        show-overflow-tooltip
        :label-class-name="col.value == 'dataTitle' ? 'data-col-label' : ''"
        :class-name="col.value == 'dataTitle' ? 'data-col' : ''"
      >
        <template slot-scope="scope">
          <template v-if="['dataTitle', 'user.name', 'verifyUser.name'].includes(col.value)">
            <template v-if="!scope.row.deleted">{{ _.get(scope.row, col.value) }}</template>
            <span v-else style="text-decoration: line-through;">数据已删除</span>
          </template>
          <template v-else>
            {{ _.get(scope.row, col.value) }}
          </template>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="160">
        <template slot-scope="scope">
          <el-button type="text" size="mini" class="operation" @click.stop="editData(scope.row)">
            编辑
          </el-button>
          <el-button
            type="text"
            size="mini"
            class="operation"
            @click.stop="cancelFavorite(scope.row)"
          >
            取消收藏
          </el-button>
        </template>
      </el-table-column>
    </base-table>
    <favorite-dialog ref="favoriteInfo" from="todo" @refresh="refresh"></favorite-dialog>
    <sheet-detail-dialog
      ref="detailDialog"
      :visible.sync="sheetDetailVisible"
      :data-id="sheetDataId"
      :app-id="sheetAppId"
      @data-changed="refreshTable"
    ></sheet-detail-dialog>
  </div>
</template>

<script>
import { favoriteColumns } from "@/views/Company/Todo/static"
import BaseTable from "@/components/UIComponents/BaseTable"
import SheetDetailDialog from "@/components/Sheet/DetailDialog"
import { getFavorites, deleteFavorite } from "@/api/user"
import FavoriteDialog from "@/components/Sheet/DetailDialog/FavoriteDialog"
import FavoriteSearch from "@/views/Company/Todo/FavoriteSearch"

export default {
  name: "Favorite",
  components: { FavoriteSearch, FavoriteDialog, BaseTable, SheetDetailDialog },
  props: {
    appId: String
  },
  data() {
    return {
      favoriteColumns,
      favoriteList: [],
      dataLoading: false,
      sheetDetailVisible: false,
      sheetDataId: "",
      sheetAppId: "",
      pageInfo: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters.userInfo
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.refreshTable()
    },
    search(key, value) {
      this.pageInfo = this.$options.data().pageInfo
      let params = {
        page: this.pageInfo.currentPage,
        size: this.pageInfo.pageSize,
        [key]: value
      }
      if (key !== "appId") {
        params.appId = this.appId
      }
      getFavorites(params)
        .then(res => {
          this.favoriteList = res.content
          this.pageInfo.total = res.totalElements
        })
        .finally(() => (this.dataLoading = false))
    },
    refreshTable() {
      this.dataLoading = true
      getFavorites({
        appId: this.appId,
        page: this.pageInfo.currentPage,
        size: this.pageInfo.pageSize
      })
        .then(res => {
          this.favoriteList = res.content
          this.pageInfo.total = res.totalElements
        })
        .finally(() => (this.dataLoading = false))
    },
    favoriteClick(favorite) {
      this.openSheetDetail(favorite)
    },
    openSheetDetail(favorite) {
      this.sheetDataId = favorite.dataId
      this.sheetAppId = favorite.appId
      this.sheetDetailVisible = true
    },
    editData(data) {
      this.$nextTick(() => {
        this.$refs.favoriteInfo?.open(data)
      })
    },
    cancelFavorite(data) {
      deleteFavorite(data.id).then(res => {
        this.refresh()
        this.$message.success("取消收藏成功")
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.favorite {
  height: 100%;
  display: flex;
  flex-flow: column;
  .title {
    padding: 18px;
    display: flex;
    justify-content: space-between;
  }
  .operation {
    font-size: 13px;
  }
  .base-table {
    flex: auto;
    overflow: hidden;
    ::v-deep {
      .data-col-label {
        color: $color-font-first;
      }
      .data-col {
        color: $color-main;
      }
    }
  }
}
</style>
